function getSessionItem(key) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (_unused) {
    return null;
  }
}
function isExpired(expires, ttl = 0) {
  const hasNoExpiry = expires === undefined;
  if (hasNoExpiry) {
    return false;
  }
  return expires + ttl < Date.now();
}
function getTourIdFromUrlParams() {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get('tourId') || searchParams.get('onboardingTourId');
}
function getLinkedTourId(checkPage = false) {
  const linkedTourKey = 'ONBOARDING_NEXT_TOUR';
  const item = getSessionItem(linkedTourKey);
  if (!item || isExpired(item.expires)) {
    return null;
  }
  const [tourId, targetPageRegex] = (item.tourId || '').split(':');
  if (checkPage && targetPageRegex && !document.location.pathname.match(targetPageRegex)) {
    return null;
  }
  return tourId || null;
}
function getCemMultiPagesTourId() {
  const cemMultiPagesTourKey = 'cem-multi-pages-tour';
  const ttl = 30 * 60 * 1000; // 30 mins
  const item = getSessionItem(cemMultiPagesTourKey);
  if (isExpired(item === null || item === void 0 ? void 0 : item.timestamp, ttl)) {
    return null;
  }
  return (item === null || item === void 0 ? void 0 : item.id) || null;
}
export function resolveTourId() {
  return getTourIdFromUrlParams() || getLinkedTourId() || getCemMultiPagesTourId();
}
export function shouldRenderTour(tourId) {
  const currentTourId = getTourIdFromUrlParams() || getLinkedTourId(true);
  if (!tourId) {
    return !!currentTourId;
  }
  if (typeof tourId === 'string') {
    return currentTourId === tourId;
  }
  if (currentTourId) {
    return tourId.includes(currentTourId);
  }
  return false;
}